import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { AzureAccountsService } from 'src/app/core/http-services/azure-accounts.service';
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service';
import { AzureAccount } from 'src/app/shared/models/azure-accounts.model';
import { UpdateActiveStatusRequest } from 'src/app/shared/models/azure-namespaces.model';

@Component({
  selector: 'app-edit-azure-account',
  templateUrl: './edit-azure-account.component.html',
  styleUrls: ['./edit-azure-account.component.css']
})
export class EditAzureAccountComponent implements OnInit {
  isSubscriptionIdEntered: boolean = true;
  isAccountNameEntered: boolean = true;

  @Input()
  currentAccount: AzureAccount;

  @Output()
  isAccountSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  azureAccountId: number;

  error: string;
  isErrorVisible: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private azureAccountsService: AzureAccountsService,
    public activeModal: NgbActiveModal,
    public router: Router,
    private confirmationDialogService: ConfirmationDialogService) {
    this.buildForm();
  }

  ngOnInit(): void {
    //THIS WILL CLOSE THE POPUP IF USER IS FORCED LOGGED OUT
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        var url = window.location.toString();
        if (url.includes('/login'))
          this.activeModal.close();
      }
    });
  }

  accountForm: FormGroup;

  private buildForm(): void {
    this.accountForm = this.formBuilder.group({
      Name: [null, Validators.required],
      SubscriptionId: [null, Validators.required],
      checkActive: [null],
    });
  }

  get f() { return this.accountForm.controls; }
  isBusy: boolean = false;
  isLoading: boolean = false;
  isValid: boolean = true;

  public setFormValues() {
    if (!this.currentAccount) {
      return;
    }

    this.f.Name.setValue(this.currentAccount.AccountName);
    this.f.SubscriptionId.setValue(this.currentAccount.SubscriptionId);
    this.f.checkActive.setValue(this.currentAccount.Active);

    //DISABLE THE CONTORLS WHEN IN EDIT MODE
    this.f.Name.disable();
    this.f.SubscriptionId.disable();
  }


  createEditAccount() {
    if (this.isBusy)
      return;

    this.isErrorVisible = false;
    this.isBusy = true;
    this.isLoading = true;
    this.isValid = true;

    let request = new AzureAccount();
    request.AccountName = this.f.Name.value;
    request.SubscriptionId = this.f.SubscriptionId.value;

    let isActive: boolean = false;
    if (this.f.checkActive.value != null) {
      isActive = this.f.checkActive.value;
    }

    if (this.azureAccountId && this.azureAccountId > 0) { //TRYING TO UPDATE STATUS
      let updateRequest = new UpdateActiveStatusRequest();
      updateRequest.id = this.azureAccountId;
      updateRequest.active = isActive;

      this.azureAccountsService.updateActiveStatus(updateRequest)
        .pipe(first())
        .subscribe(
          data => {
            this.isLoading = false;
            this.isBusy = false;

            this.isAccountSaved.emit(true);
            this.activeModal.close();
          },
          error => {
            this.error = error;
            this.isErrorVisible = true;
            this.isLoading = false;
            this.isBusy = false;
          }
        )
    }
    else { //TRYING TO CREATE A NEW ACCOUNT
      request.Id = 0;
      this.isAccountNameEntered = this.f.Name.valid;
      this.isSubscriptionIdEntered = this.f.SubscriptionId.valid;

      if (!this.isAccountNameEntered || !this.isSubscriptionIdEntered) {
        this.isBusy = false;
        this.isLoading = false;
        return;
      }

      this.azureAccountsService.createAccount(request)
        .pipe(first())
        .subscribe(
          data => {
            this.isLoading = false;
            this.isBusy = false;

            this.isAccountSaved.emit(true);
            this.activeModal.close();
          },
          error => {
            this.error = error;
            this.isErrorVisible = true;
            this.isLoading = false;
            this.isBusy = false;
          }
        )
    }



  }

}
